const HANDOFF_KEY = 'zeedcom-assistant-handoff';

export type AssistantSearchHandoff = {
  type: 'search';
  query_tree: unknown;
  hint?: string;
  apply?: boolean;
};

export type AssistantOrderHandoff = {
  type: 'order';
  prefill: {
    client_name?: string;
    phone?: string;
    city?: string;
  };
};

export type AssistantHandoff = AssistantSearchHandoff | AssistantOrderHandoff;

export const ASSISTANT_HANDOFF_EVENT = 'zeedcom-assistant-handoff';

export function setAssistantHandoff(payload: AssistantHandoff): void {
  try {
    sessionStorage.setItem(HANDOFF_KEY, JSON.stringify(payload));
    window.dispatchEvent(new CustomEvent(ASSISTANT_HANDOFF_EVENT));
  } catch {
    // stockage indisponible
  }
}

export function takeAssistantHandoff(): AssistantHandoff | null {
  try {
    const raw = sessionStorage.getItem(HANDOFF_KEY);
    if (!raw) return null;
    sessionStorage.removeItem(HANDOFF_KEY);
    const parsed = JSON.parse(raw) as AssistantHandoff;
    if (!parsed || (parsed.type !== 'search' && parsed.type !== 'order')) return null;
    return parsed;
  } catch {
    try {
      sessionStorage.removeItem(HANDOFF_KEY);
    } catch {
      // ignore
    }
    return null;
  }
}
